export function initOtpInput() {
  const boxes = document.querySelectorAll('[data-otp-input]');
  if (!boxes.length) return;

  boxes.forEach((box, idx) => {
    box.addEventListener('input', e => {
      const val = e.target.value.replace(/\D/g, '');
      box.value = val.slice(-1);
      if (val && idx < boxes.length - 1) {
        boxes[idx + 1].focus();
      }
    });

    box.addEventListener('keydown', e => {
      if (e.key === 'Backspace' && !box.value && idx > 0) {
        boxes[idx - 1].focus();
        boxes[idx - 1].value = '';
      }
    });

    box.addEventListener('paste', e => {
      e.preventDefault();
      const paste = (e.clipboardData || window.clipboardData).getData('text').replace(/\D/g, '');
      boxes.forEach((b, i) => {
        b.value = paste[i] || '';
      });
      const lastFilled = Math.min(paste.length, boxes.length) - 1;
      if (lastFilled >= 0) boxes[lastFilled].focus();
    });
  });
}
